module.exports = __webpack_public_path__ + "static/media/blog1Sub.c792c8b1.jpg";